<!--  -->
<template>
  <div>
    <el-form
      :label-position="'right'"
      label-width="100px"
    >
      <el-form-item label="变色龙订单ID">
        <el-input
          v-model="order_id"
          autocomplete="off"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { adxaccountcreatebianse, adxaccountupdatebianse } from '@/api/report/adx'
export default {
  components: {},
  data() {
    return {
      addtype: null,
      order_id: '',
      id: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      this.addtype = type
      if (this.addtype === 2) {
        this.id = item.id
        console.log('item', item)
        this.order_id = item.order_id
      }
    },
    async sumbitr() {
      if (this.order_id === '') {
        this.$message.error('请输入变色龙ID')
        return
      }
      if (this.addtype === 1) {
        const data = await adxaccountcreatebianse({
          order_id: this.order_id
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        const data = await adxaccountupdatebianse({
          id: this.id,
          order_id: this.order_id
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
